/**
 * DiagnosisBlock — the tutor-feedback F3 diagnosis: the named cause of a
 * wrong/partial answer plus a chip for its kind. Renders nothing when
 * `diagnosisForStudent` says there is nothing to show (see diagnosisLabels.ts).
 * See docs/FeatureDesigns/diagnosis/tutor-feedback-model.md.
 */
import type { Diagnosis } from '@padcanvas/shared';
import { LatexText } from '../../latex';
import { diagnosisForStudent } from './diagnosisLabels';

interface Props {
    diagnosis: Diagnosis | undefined;
}

export function DiagnosisBlock({ diagnosis }: Props) {
    const shown = diagnosisForStudent(diagnosis);
    if (!shown) return null;
    return (
        <section className="sol-section sol-diagnosis">
            <div className="sol-diagnosis-head">
                <span className={`sol-diagnosis-chip sol-diagnosis-chip--${shown.kind}`}>{shown.label}</span>
            </div>
            <p className="sol-diagnosis-cause"><LatexText text={shown.cause} /></p>
        </section>
    );
}
